import {
  AUTH_LOGIN_UNAUTHORIZED,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT,
  AUTH_START_LOGIN_REQUEST,
  AUTH_FINISH,
} from '../constants/AUTH_CONSTANTS'

const initialState = {
  data: {
    user: null,
    isAuthenticated: false,
    isAuthorized: false,
    isLoading: false,
  },
}

export default function auth_reducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_LOGIN_SUCCESS:
      return {
        data: {
          user: action.data,
          isAuthenticated: true,
          isAuthorized: true,
          isLoading: false,
        },
      }

    case AUTH_LOGIN_UNAUTHORIZED:
      return {
        data: {
          user: null,
          isAuthenticated: true,
          isAuthorized: false,
          isLoading: false,
        },
      }
    case AUTH_START_LOGIN_REQUEST:
      return {
        data: {
          user: null,
          isAuthenticated: false,
          isAuthorized: false,
          isLoading: true,
        },
      }

    case AUTH_LOGOUT:
      return {
        data: {
          user: null,
          isAuthenticated: false,
          isAuthorized: false,
          isLoading: false,
        },
      }
    case AUTH_FINISH:
      return {
        data: {
          ...state.data,
          isLoading: false,
        },
      }
    default:
      return state
  }
}
